import { TDeviceType } from '@cian/ui-kit';

interface IParams {
  preview?: number;
  thumbnail?: number;
}

type TAspectRatio = Record<TDeviceType, IParams>;

export const aspectRatio: TAspectRatio = {
  phone: {
    preview: 0.57,
    thumbnail: 0.58,
  },
  tablet: {
    preview: 0.61,
    thumbnail: 0.67,
  },
  desktop: {},
};
